module.exports = __webpack_public_path__ + "img/logout-icon.3b9e88d4.svg";